import { CallLogs } from '@/features/customers/components/CallLogs';
import { EventContext } from '@/features/events/contexts/EventContext';
import { useContext } from 'react';

export const CallsTab = () => {
  const { event } = useContext(EventContext);

  if (!event) return <>Loading...</>;

  if (!event.customer) return <>No customer found.</>;

  return <CallLogs customer={event.customer} location={event.franchise_id} />;
};
